// extracted by mini-css-extract-plugin
module.exports = {"impressum":"Impressum_impressum__5Zrww"};